import ExploreFeatureCard from "components/Loaders/ExploreFeatureCard";
import SwipableView from "components/UI/organisms/SwipableView";
import React from "react";
import { useTranslation } from "react-i18next";
import FeatureCard from "./FeatureCard";
import { NoDataView } from "components/UI/organisms/ListingContainer";
import { COMPONENT_TYPES } from "helpers/utils/constants";

const FeaturedSection = ({ loading, featured = [], width }) => {
  const { t } = useTranslation("explore");
  return (
    <div className="container mt-20">
      <h2>{t("Featured By Prepr")}</h2>
      {loading ? (
        <SwipableView slidesPerView={width > 1000 ? 2 : 1}>
          {Array.from({ length: 2 }, (_, i) => (
            <ExploreFeatureCard key={i} />
          ))}
        </SwipableView>
      ) : featured?.length > 0 ? (
        <SwipableView slidesPerView={width > 1000 ? 2 : 1}>
          {featured?.map((d, i) => (
            <FeatureCard
              key={i}
              title={d?.title}
              description={d?.description}
              image={d?.media}
              slug={d?.module_slug}
              type={
                d?.module_type === "labs"
                  ? COMPONENT_TYPES.LAB
                  : COMPONENT_TYPES.CHALLENGE
              }
              buttonTitle={d?.button_text}
            />
          ))}
        </SwipableView>
      ) : (
        <NoDataView classes="my-5" text={t("No featured labs found")} small />
      )}
    </div>
  );
};

export default FeaturedSection;
